<template>
  <div class="auth-page">
    <div class="auth-hero">
      <img class="auth-logo" src="~@/assets/image/logo.png" alt="logo">
    </div>

    <div class="auth-tabs">
      <button class="auth-tab active" type="button">登录</button>
      <button class="auth-tab" type="button" @click="goRegister">注册</button>
    </div>

    <div class="auth-form login-form">
      <div class="field-group">
        <div class="field-label">手机号</div>
        <input v-model.trim="form.account" class="auth-input" type="tel" placeholder="请输入手机号">
      </div>

      <div class="field-group">
        <div class="field-label">密码</div>
        <input v-model.trim="form.password" class="auth-input" type="password" placeholder="请输入密码">
      </div>

      <button class="primary-btn" type="button" :disabled="loading" @click="handleLogin">
        {{ loading ? '登录中...' : '立即登录' }}
      </button>

      <button class="text-link forgot-link" type="button" @click="goForgot">
        <van-icon name="lock" />
        忘记密码?
      </button>
    </div>
  </div>
</template>

<script>
import { userLogin, getLoginInfo } from '@/api/index.js'

export default {
  data() {
    return {
      loading: false,
      form: {
        account: '',
        password: '',
        rememberMe: true
      }
    }
  },
  methods: {
    goRegister() {
      this.$router.push({
        path: '/register',
        query: this.$route.query.redirect ? { redirect: this.$route.query.redirect } : {}
      })
    },
    goForgot() {
      this.$router.push('/forgot-password')
    },
    handleLogin() {
      if (!this.form.account) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.form.password) {
        this.$toast('请输入密码')
        return
      }

      this.loading = true
      userLogin(this.form).then(() => {
        this.loadUserInfo()
        this.$toast.success('登录成功')
        const redirect = this.$route.query.redirect ? decodeURIComponent(this.$route.query.redirect) : '/evaluation'
        this.$router.replace(redirect)
      }).finally(() => {
        this.loading = false
      })
    },
    loadUserInfo() {
      getLoginInfo().then(res => {
        if (res.data) {
          this.$store.commit('setUserInfo', {
            id: res.data.id || '',
            name: res.data.name || '',
            account: res.data.account || '',
            avatar: res.data.avatar || '',
            idCard: res.data.idCard || '',
            phone: res.data.phone || '',
            hospital: res.data.hospital || '',
            type: res.data.type || ''
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
